import { __ } from '@wordpress/i18n';
import { FAQ_DATA } from './constants';

/**
 * @param {Object}   props
 * @param {number}   props.openFaq     - index of currently open item, -1 for none
 * @param {Function} props.setOpenFaq
 */
const Faq = ({ openFaq, setOpenFaq }) => (
    <div className="f-pricing__faq">
        <div className="f-pricing__faq-header">
            <h2>{__('Frequently asked questions', 'jeg-elementor-kit')}</h2>
            <p>{__('Everything you need to know about the product and billing.', 'jeg-elementor-kit')}</p>
        </div>
        <div className="f-pricing__faq-list">
            {FAQ_DATA.map((item, idx) => (
                <div
                    key={idx}
                    className={`f-pricing__faq-item${openFaq === idx ? ' is-open' : ''}`}
                >
                    <button
                        className="f-pricing__faq-q"
                        onClick={() => setOpenFaq(openFaq === idx ? -1 : idx)}
                    >
                        <span>{item.q}</span>
                        <span className="f-pricing__faq-icon">
                            {openFaq === idx ? (
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5 12H19" stroke="#A4A7AE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            ) : (
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 5V19M5 12H19" stroke="#7D8292" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            )}
                        </span>
                    </button>
                    {openFaq === idx && (
                        <div className="f-pricing__faq-a">{item.a}</div>
                    )}
                </div>
            ))}
        </div>
    </div>
);

export default Faq;
